import store from '@state/store'


var export_routes = [
  {
    path: '/',
    name: 'home',
    component: () => lazyLoadView(import('@views/dashboard/dashboard')),
    meta: {
      authRequired: true,
    },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  },
];

import { UsersList, UsersSingle } from 'coryallen-users'
export_routes.push({
  path: '/contacts', name: 'contacts', component: UsersList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: UsersSingle,
    meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { ListingsList, ListingsSingle } from 'coryallen-listings'
export_routes.push({
  path: '/listings', name: 'listings', component: ListingsList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: ListingsSingle,
    meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { CartsList } from 'coryallen-carts'
export_routes.push({
  path: '/carts', name: 'Carts', component: CartsList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
});

import { ServicesList } from 'coryallen-services'
export_routes.push({
  path: '/packages', name: 'packages', component: ServicesList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
});

// import { LeadsList, LeadRecipientsList, LeadRecipientsSingle, LeadTypesList, LeadTypesSingle } from 'coryallen-leads'
// export_routes.push({
//   path: '/leads', name: 'leads', component: LeadsList,
//   meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Lead Admin'], },
//   props: (route) => ({ user: store.state.auth.currentUser || {} }),
//   children: [{
//     path: ':id', component: PeopleSingle,
//     meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Lead Admin'], },
//     props: (route) => ({ user: store.state.auth.currentUser || {} }),
//   }]
// });
// export_routes.push({
//   path: '/myleads', name: 'myleads', component: LeadsList,
//   meta: { authRequired: true, roles: ['Lead User'], },
//   props: (route) => ({ user: store.state.auth.currentUser || {} }),
//   children: [{
//     path: ':id', component: PeopleSingle,
//     meta: { authRequired: true, roles: ['Lead User'], },
//     props: (route) => ({ user: store.state.auth.currentUser || {} }),
//   }]
// });
// export_routes.push({
//   path: '/leadrecipients', name: 'leadrecipients', component: LeadRecipientsList,
//   meta: { authRequired: true, roles: ['Dev','Admin'], },
//   props: (route) => ({ user: store.state.auth.currentUser || {} }),
//   children: [{
//     path: ':id', component: LeadRecipientsSingle,
//     meta: { authRequired: true, roles: ['Dev','Admin'], },
//     props: (route) => ({ user: store.state.auth.currentUser || {} }),
//   }]
// });
// export_routes.push({
//   path: '/leadtypes', name: 'leadtypes', component: LeadTypesList,
//   meta: { authRequired: true, roles: ['Dev','Admin'], },
//   props: (route) => ({ user: store.state.auth.currentUser || {} }),
//   children: [{
//     path: ':id', component: LeadTypesSingle,
//     meta: { authRequired: true, roles: ['Dev','Admin'], },
//     props: (route) => ({ user: store.state.auth.currentUser || {} }),
//   }]
// });

import { PagesList, PagesSingle } from 'coryallen-pages'
export_routes.push({
  path: '/pages', name: 'pages', component: PagesList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: PagesSingle,
    meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { BlogsList, BlogsSingle } from 'coryallen-blogs'
export_routes.push({
  path: '/blogs', name: 'blogs', component: BlogsList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: BlogsSingle,
    meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { VendorsList, VendorsSingle } from 'coryallen-vendors'
export_routes.push({
  path: '/vendors', name: 'vendors', component: VendorsList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: VendorsSingle,
    meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { FaqsList, FaqsSingle } from 'coryallen-faqs'
export_routes.push({
  path: '/faqs', name: 'faqs', component: FaqsList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: FaqsSingle,
    meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { TestimonialsList, TestimonialsSingle } from 'coryallen-testimonials'
export_routes.push({
  path: '/testimonials', name: 'testimonials', component: TestimonialsList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: TestimonialsSingle,
    meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { FileManagerList } from 'coryallen-filemanager'
export_routes.push({
  path: '/file-manager', name: 'file-manager', component: FileManagerList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
});

import { PageViewsList } from 'coryallen-page-views'
export_routes.push({
  path: '/page-views', name: 'page-views', component: PageViewsList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
});

import { InboxList, InboxSingle } from 'coryallen-inbox'
export_routes.push({
  path: '/inbox', name: 'inbox', component: InboxList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: InboxSingle,
    meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { StoresList, StoresSingle } from 'coryallen-stores'
export_routes.push({
  path: '/stores', name: 'stores', component: StoresList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: StoresSingle,
    meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { DocsList } from 'coryallen-docs'
export_routes.push({
  path: '/docs', name: 'docs', component: DocsList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: DocsList,
    meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { TrackersList, TrackersSingle } from 'coryallen-trackers'
export_routes.push({
  path: '/trackers', name: 'trackers', component: TrackersList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: TrackersSingle,
    meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee','Admin Social'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { MlssList, MlssSingle } from 'coryallen-mlss'
export_routes.push({
  path: '/mlss', name: 'mlss', component: MlssList,
  meta: { authRequired: true, roles: ['Dev','Admin'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: MlssSingle,
    meta: { authRequired: true, roles: ['Dev','Admin'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { DblogsList, DblogsSingle } from 'coryallen-dblogs'
export_routes.push({
  path: '/dblogs', name: 'dblogs', component: DblogsList,
  meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: DblogsSingle,
    meta: { authRequired: true, roles: ['Dev','Admin','Admin Employee'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { CommunicationsList } from 'coryallen-communications'
export_routes.push({
  path: '/communications', name: 'communications', component: CommunicationsList,
  meta: { authRequired: true, roles: ['Dev','Admin'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
});

import { TasksList, TasksSingle } from 'coryallen-tasks'
export_routes.push({
  path: '/tasks', name: 'tasks', component: TasksList,
  meta: { authRequired: true, roles: ['Dev','Admin'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: TasksSingle,
    meta: { authRequired: true, roles: ['Dev','Admin'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});

import { WebsitesList, WebsitesSingle } from 'coryallen-websites'
export_routes.push({
  path: '/websites', name: 'websites', component: WebsitesList,
  meta: { authRequired: true, roles: ['Dev','Admin'], },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
  children: [{
    path: ':id', component: WebsitesSingle,
    meta: { authRequired: true, roles: ['Dev','Admin'], },
    props: (route) => ({ user: store.state.auth.currentUser || {} }),
  }]
});


export_routes.push({
  path: '/login',
  name: 'login',
  component: () => lazyLoadView(import('@views/login')),
  meta: {
    beforeResolve(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the home page instead
        next({ name: 'home' })
      } else {
        // Continue to the login page
        next()
      }
    },
  },
});
export_routes.push({
  path: '/register',
  name: 'register',
  component: () => lazyLoadView(import('@views/register')),
  meta: {
    beforeResolve(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the home page instead
        next({ name: 'home' })
      } else {
        // Continue to the login page
        next()
      }
    },
  },
});
export_routes.push({
  path: '/confirm-account',
  name: 'confirm-account',
  component: () => lazyLoadView(import('@views/confirm')),
  meta: {
    beforeResolve(routeTo, routeFrom, next) {
      // If the user is already logged in
      next()
      // if (store.getters['auth/loggedIn']) {
      //   // Redirect to the home page instead
      //   next({ name: 'home' })
      // } else {
      //   // Continue to the login page
      //   next()
      // }
    },
  },
  props: (route) => ({ user: store.state.auth.currentUser || {} }),
});
export_routes.push({
  path: '/forget-password',
  name: 'forget-password',
  component: () => lazyLoadView(import('@views/forgetPassword')),
  meta: {
    beforeResolve(routeTo, routeFrom, next) {
      // If the user is already logged in
      if (store.getters['auth/loggedIn']) {
        // Redirect to the home page instead
        next({ name: 'home' })
      } else {
        // Continue to the login page
        next()
      }
    },
  },
});
export_routes.push({
  path: '/logout',
  name: 'logout',
  meta: {
    authRequired: true,
    beforeResolve(routeTo, routeFrom, next) {
      store.dispatch('auth/logOut')
      const authRequiredOnPreviousRoute = routeFrom.matched.some(
        (route) => route.meta.authRequired
      )
      // Navigate back to previous page, or home as a fallback
      next(authRequiredOnPreviousRoute ? { name: 'home' } : { ...routeFrom })
    },
  },
});
export_routes.push({
  path: '/404',
  name: '404',
  component: require('@views/_404').default,
  // Allows props to be passed to the 404 page through route
  // params, such as `resource` to define what wasn't found.
  props: true,
},
// Redirect any unmatched routes to the 404 page. This may
// require some server configuration to work in production:
// https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
{
  path: '*',
  redirect: '404',
});

export default export_routes

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require('@views/_loading').default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 200,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require('@views/_timeout').default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children)
    },
  })
}
